import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'AdminUsersRole',
    column_type: 'id',
  },
  created_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
  },
  role: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'role',
      model_name: 'Role',
      foreign_key: 'role_id',
    },
  },
  role_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'role',
      model_name: 'Role',
      foreign_key: 'role_id',
    },
  },
  admin_user: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'admin_user',
      model_name: 'AdminUser',
      foreign_key: 'admin_user_id',
    },
  },
  admin_user_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'admin_user',
      model_name: 'AdminUser',
      foreign_key: 'admin_user_id',
    },
  },
  application: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  application_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  is_block: {
    model_name: 'AdminUsersRole',
    column_type: 'boolean',
  },
  admin_user_attributes: {
    model_name: 'AdminUsersRole',
    column_type: 'string',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
